import { useContext } from 'react';
import { DisconnectPixelModalContext } from './DisconnectPixelModalContext';

const useDisconnectPixelModal = () => {
  const { open } = useContext(DisconnectPixelModalContext);
  return { open };
};

export default useDisconnectPixelModal;
